import React from 'react';
import { FadeIn } from './FadeIn';
export function GuaranteeSection() {
  return <section className="py-12 px-4 bg-cream" data-id="element-118">
      <div className="max-w-3xl mx-auto" data-id="element-119">
        <FadeIn data-id="element-120">
          <div className="bg-white rounded-2xl p-8 md:p-10 border-2 border-dashed border-green-mint text-center shadow-sm" data-id="element-121">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-green-mint/20 rounded-full mb-6 text-4xl" data-id="element-122">
              🛡️
            </div>

            <h3 className="font-heading font-bold text-2xl md:text-3xl text-green-deep mb-4" data-id="element-123">
              GARANTÍA DE 30 DÍAS — 100% DEVOLUCIÓN
            </h3>

            <p className="text-text-main/80 text-base md:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-124">
              Si en 30 días no sentís que este protocolo tiene el valor que
              prometemos, te devolvemos cada centavo. Sin formularios. Sin
              explicaciones. Sin rodeos.
            </p>

            <p className="font-bold text-green-deep mt-6 text-lg" data-id="element-125">
              El riesgo es completamente nuestro.
              <br data-id="element-126" />
              El beneficio es completamente tuyo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}